import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Home from '@/components/Home';

import DataCharts from '@/components/DataCharts';

// 用户管理/权限管理
import UserMana from '@/components/UserMana';

// 资讯详情
import CateMana from '@/pages/article/CateMana';
import BlogDetail from '@/pages/article/BlogDetail';
import ArticleList from '@/pages/article/ArticleList';
import PostArticle from '@/pages/article/PostArticle';

// 欢迎页面
import Welcome from '@/pages/welcome/index';

// banner页面
import BannerList from '@/pages/banner/bannerList';
import UpdateBanner from '@/pages/banner/changeBanner';

// 代理商
import AgentList from '@/pages/agent/AgentList';
import AddAgent from '@/pages/agent/AddAgent';

// 产品管理
import ProductList from '@/pages/product/category';
import AllProduct from '@/pages/product/productList';
import ProductDetail from '@/pages/product/productDetail';
import EditProductDetail from '@/pages/product/editProductDetail';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: '登录',
            hidden: true,
            component: Login,
        },
        {
            path: '/home',
            name: '欢迎页面',
            component: Home,
            hidden: true,
            redirect: '/welcome',
            children: [
                {
                    path: '/welcome',
                    name: '欢迎页面',
                    component: Welcome,
                },
            ],
        },
        // {
        //     path: "/home",
        //     name: "banner页面",
        //     component: Home,
        //     children: [
        //         {
        //             path: "/banner",
        //             name: "banner页面",
        //             component: BannerList
        //         },
        //         {
        //             path: "/addBanner",
        //             name: "添加banner",
        //             component: UpdateBanner
        //         }
        //     ]
        // },
        {
            path: '/home',
            component: Home,
            name: '资讯管理',
            iconCls: 'fa fa-file-text-o',
            children: [
                {
                    path: '/cateMana',
                    iconCls: 'fa fa-reorder',
                    name: '栏目管理',
                    component: CateMana,
                },
                {
                    path: '/articleList',
                    name: '资讯列表',
                    component: ArticleList,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/postArticle',
                    name: '发表资讯',
                    component: PostArticle,
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: '/blogDetail',
                    name: '资讯详情',
                    component: BlogDetail,
                    hidden: true,
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: '/editBlog',
                    name: '编辑资讯',
                    component: PostArticle,
                    hidden: true,
                    meta: {
                        keepAlive: false,
                    },
                },
            ],
        },
        {
            path: '/home',
            component: Home,
            name: '合作管理',
            iconCls: 'fa fa-user-o',
            children: [
                {
                    path: '/agentList',
                    name: '代理商列表',
                    component: AgentList,
                },
                {
                    path: '/addAgent',
                    name: '添加代理商',
                    component: AddAgent,
                },
            ],
        },
        {
            path: '/home',
            component: Home,
            name: '产品管理',
            iconCls: 'fa fa-reorder',
            children: [
                {
                    path: '/productList',
                    name: '产品分类',
                    component: ProductList,
                },
                {
                    path: '/allProduct',
                    name: '产品列表',
                    component: AllProduct,
                },
                {
                    path: '/productDetail',
                    name: '产品详情',
                    component: ProductDetail,
                    hidden: true,
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: '/editProductDetail',
                    name: '编辑产品参数',
                    component: EditProductDetail,
                    hidden: true,
                    meta: {
                        keepAlive: false,
                    },
                },
            ],
        },
        {
            path: '/home',
            component: Home,
            name: '权限管理',
            children: [
                {
                    path: '/user',
                    iconCls: 'fa fa-user-o',
                    name: '权限管理',
                    component: UserMana,
                },
            ],
        },
        // {
        //     path: "/home",
        //     component: Home,
        //     name: "数据统计",
        //     iconCls: "fa fa-bar-chart",
        //     children: [
        //         {
        //             path: "/charts",
        //             iconCls: "fa fa-bar-chart",
        //             name: "数据统计",
        //             component: DataCharts
        //         }
        //     ]
        // }
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js